import camelcase from "camelcase";
import { FORM_ERROR } from "final-form";
import isUndefined from "lodash/isUndefined";
import isEmpty from "lodash/isEmpty";

export const createErrors = (error, form_error_message, handleError) => {
  let errorBj = {};

  if (error?.response.status === 500) {
    handleError(error);
    return errorBj;
  }

  if (!isUndefined(error?.response.data.errors)) {
    error.response.data.errors.map((error) => {
      errorBj[camelcase(error.id)] = error.detail;
    });
  }

  if (!isEmpty(form_error_message)) {
    errorBj[FORM_ERROR] = form_error_message;
  }
  return errorBj;
};
